/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoCustomerNumber } from './HeoCustomerNumber';
import {
    HeoCustomerNumberFromJSON,
    HeoCustomerNumberFromJSONTyped,
    HeoCustomerNumberToJSON,
    HeoCustomerNumberToJSONTyped,
} from './HeoCustomerNumber';
import type { OrderOrigin } from './OrderOrigin';
import {
    OrderOriginFromJSON,
    OrderOriginFromJSONTyped,
    OrderOriginToJSON,
    OrderOriginToJSONTyped,
} from './OrderOrigin';
import type { OrderType } from './OrderType';
import {
    OrderTypeFromJSON,
    OrderTypeFromJSONTyped,
    OrderTypeToJSON,
    OrderTypeToJSONTyped,
} from './OrderType';
import type { HeoTransactionNumber } from './HeoTransactionNumber';
import {
    HeoTransactionNumberFromJSON,
    HeoTransactionNumberFromJSONTyped,
    HeoTransactionNumberToJSON,
    HeoTransactionNumberToJSONTyped,
} from './HeoTransactionNumber';
import type { HeoItemId } from './HeoItemId';
import {
    HeoItemIdFromJSON,
    HeoItemIdFromJSONTyped,
    HeoItemIdToJSON,
    HeoItemIdToJSONTyped,
} from './HeoItemId';
import type { HeoCustomerOrderNumber } from './HeoCustomerOrderNumber';
import {
    HeoCustomerOrderNumberFromJSON,
    HeoCustomerOrderNumberFromJSONTyped,
    HeoCustomerOrderNumberToJSON,
    HeoCustomerOrderNumberToJSONTyped,
} from './HeoCustomerOrderNumber';

/**
 * 
 * @export
 * @interface InvoiceItemSummary
 */
export interface InvoiceItemSummary {
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemSummary
     */
    id: string;
    /**
     * 
     * @type {HeoItemId}
     * @memberof InvoiceItemSummary
     */
    heoItemId: HeoItemId;
    /**
     * 
     * @type {HeoCustomerNumber}
     * @memberof InvoiceItemSummary
     */
    customerNumber: HeoCustomerNumber;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItemSummary
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItemSummary
     */
    pricePerUnit: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItemSummary
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItemSummary
     */
    discount: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItemSummary
     */
    discountedPricePerUnit: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemSummary
     */
    customerReference: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemSummary
     */
    customerItemReference: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItemSummary
     */
    freightSurcharge: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItemSummary
     */
    unDiscountedFreightSurchargePrice: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemSummary
     */
    productId: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemSummary
     */
    productNumber: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemSummary
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemSummary
     */
    productImageUrl: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemSummary
     */
    productThumbnailUrl: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemSummary
     */
    productOriginCountry: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemSummary
     */
    productTariffNumber: string;
    /**
     * 
     * @type {HeoTransactionNumber}
     * @memberof InvoiceItemSummary
     */
    invoiceNumber: HeoTransactionNumber;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItemSummary
     */
    invoiceTotal: number;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceItemSummary
     */
    invoiceCanceled: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemSummary
     */
    invoiceReasonOfCancellation: string;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceItemSummary
     */
    invoiceCreatedAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceItemSummary
     */
    isVirtual: boolean;
    /**
     * 
     * @type {HeoCustomerOrderNumber}
     * @memberof InvoiceItemSummary
     */
    customerOrderNumber?: HeoCustomerOrderNumber;
    /**
     * 
     * @type {OrderOrigin}
     * @memberof InvoiceItemSummary
     */
    orderOrigin?: OrderOrigin;
    /**
     * 
     * @type {OrderType}
     * @memberof InvoiceItemSummary
     */
    orderType?: OrderType;
}



/**
 * Check if a given object implements the InvoiceItemSummary interface.
 */
export function instanceOfInvoiceItemSummary(value: object): value is InvoiceItemSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('heoItemId' in value) || value['heoItemId'] === undefined) return false;
    if (!('customerNumber' in value) || value['customerNumber'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('pricePerUnit' in value) || value['pricePerUnit'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('discountedPricePerUnit' in value) || value['discountedPricePerUnit'] === undefined) return false;
    if (!('customerReference' in value) || value['customerReference'] === undefined) return false;
    if (!('customerItemReference' in value) || value['customerItemReference'] === undefined) return false;
    if (!('freightSurcharge' in value) || value['freightSurcharge'] === undefined) return false;
    if (!('unDiscountedFreightSurchargePrice' in value) || value['unDiscountedFreightSurchargePrice'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('productNumber' in value) || value['productNumber'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('productImageUrl' in value) || value['productImageUrl'] === undefined) return false;
    if (!('productThumbnailUrl' in value) || value['productThumbnailUrl'] === undefined) return false;
    if (!('productOriginCountry' in value) || value['productOriginCountry'] === undefined) return false;
    if (!('productTariffNumber' in value) || value['productTariffNumber'] === undefined) return false;
    if (!('invoiceNumber' in value) || value['invoiceNumber'] === undefined) return false;
    if (!('invoiceTotal' in value) || value['invoiceTotal'] === undefined) return false;
    if (!('invoiceCanceled' in value) || value['invoiceCanceled'] === undefined) return false;
    if (!('invoiceReasonOfCancellation' in value) || value['invoiceReasonOfCancellation'] === undefined) return false;
    if (!('invoiceCreatedAt' in value) || value['invoiceCreatedAt'] === undefined) return false;
    if (!('isVirtual' in value) || value['isVirtual'] === undefined) return false;
    return true;
}

export function InvoiceItemSummaryFromJSON(json: any): InvoiceItemSummary {
    return InvoiceItemSummaryFromJSONTyped(json, false);
}

export function InvoiceItemSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceItemSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'heoItemId': HeoItemIdFromJSON(json['heoItemId']),
        'customerNumber': HeoCustomerNumberFromJSON(json['customerNumber']),
        'quantity': json['quantity'],
        'pricePerUnit': json['pricePerUnit'],
        'total': json['total'],
        'discount': json['discount'],
        'discountedPricePerUnit': json['discountedPricePerUnit'],
        'customerReference': json['customerReference'],
        'customerItemReference': json['customerItemReference'],
        'freightSurcharge': json['freightSurcharge'],
        'unDiscountedFreightSurchargePrice': json['unDiscountedFreightSurchargePrice'],
        'productId': json['productId'],
        'productNumber': json['productNumber'],
        'productName': json['productName'],
        'productImageUrl': json['productImageUrl'],
        'productThumbnailUrl': json['productThumbnailUrl'],
        'productOriginCountry': json['productOriginCountry'],
        'productTariffNumber': json['productTariffNumber'],
        'invoiceNumber': HeoTransactionNumberFromJSON(json['invoiceNumber']),
        'invoiceTotal': json['invoiceTotal'],
        'invoiceCanceled': json['invoiceCanceled'],
        'invoiceReasonOfCancellation': json['invoiceReasonOfCancellation'],
        'invoiceCreatedAt': (new Date(json['invoiceCreatedAt'])),
        'isVirtual': json['isVirtual'],
        'customerOrderNumber': json['customerOrderNumber'] == null ? undefined : HeoCustomerOrderNumberFromJSON(json['customerOrderNumber']),
        'orderOrigin': json['orderOrigin'] == null ? undefined : OrderOriginFromJSON(json['orderOrigin']),
        'orderType': json['orderType'] == null ? undefined : OrderTypeFromJSON(json['orderType']),
    };
}

export function InvoiceItemSummaryToJSON(json: any): InvoiceItemSummary {
    return InvoiceItemSummaryToJSONTyped(json, false);
}

export function InvoiceItemSummaryToJSONTyped(value?: InvoiceItemSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'heoItemId': HeoItemIdToJSON(value['heoItemId']),
        'customerNumber': HeoCustomerNumberToJSON(value['customerNumber']),
        'quantity': value['quantity'],
        'pricePerUnit': value['pricePerUnit'],
        'total': value['total'],
        'discount': value['discount'],
        'discountedPricePerUnit': value['discountedPricePerUnit'],
        'customerReference': value['customerReference'],
        'customerItemReference': value['customerItemReference'],
        'freightSurcharge': value['freightSurcharge'],
        'unDiscountedFreightSurchargePrice': value['unDiscountedFreightSurchargePrice'],
        'productId': value['productId'],
        'productNumber': value['productNumber'],
        'productName': value['productName'],
        'productImageUrl': value['productImageUrl'],
        'productThumbnailUrl': value['productThumbnailUrl'],
        'productOriginCountry': value['productOriginCountry'],
        'productTariffNumber': value['productTariffNumber'],
        'invoiceNumber': HeoTransactionNumberToJSON(value['invoiceNumber']),
        'invoiceTotal': value['invoiceTotal'],
        'invoiceCanceled': value['invoiceCanceled'],
        'invoiceReasonOfCancellation': value['invoiceReasonOfCancellation'],
        'invoiceCreatedAt': value['invoiceCreatedAt'].toISOString(),
        'isVirtual': value['isVirtual'],
        'customerOrderNumber': HeoCustomerOrderNumberToJSON(value['customerOrderNumber']),
        'orderOrigin': OrderOriginToJSON(value['orderOrigin']),
        'orderType': OrderTypeToJSON(value['orderType']),
    };
}

